import { render, staticRenderFns } from "./ChatLogin.vue?vue&type=template&id=3763c5d7&scoped=true&"
import script from "./ChatLogin.vue?vue&type=script&lang=js&"
export * from "./ChatLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763c5d7",
  null
  
)

export default component.exports